<template>
  <header class="header">
    <div class="contentBox">
      <div class="logo">
        <img :src="logoSrc">
      </div>
      <div class="navBox">
        <div class="seachBox">
          <input type="text" class="seachInput" placeholder="search" v-model="seachval">
          <router-link :to="{name:'search',params:{seachval:seachval}}" @click='searchFn(seachval)'><i class="seachImg"></i></router-link>
          
          <!-- <img class="seachImg" src="@/assets/images/seachImg.png"> -->
        </div>
        <ul class="navUl">
          <li class="navli" v-for="(item,key) in navlist" :key="key" @click="yiweiFn()">
            <router-link :to="item.url">{{item.name}}</router-link>
            <ul class="childUl" v-if="item.child" v-show="isShow">
              <li v-for="(childitem,childkey) in item.child" :key="childkey">
                <router-link
                  :to="childitem.url"
                  @click.native="childLink(childitem.name)"
                >{{childitem.name}}</router-link>
              </li>
            </ul>
          </li> 
        </ul>
      </div>
    </div>
  </header>
</template>

<script>
import "../assets/css/header.less";
import apiSign from "../assets/js/apiSign";

export default {
  name: "",
  props: {
    msg: String
  },
  data() {
    return {
      seachval: "",
      navlist: [],
      isShow: false,
      logoSrc:''
    };  
  },
  
  mounted() {
    this.getNavFn();
  },
  beforeDestroy(){
    this.seachval = ''
  },
  methods: {
    getNavFn() {
      let storageNavbar = sessionStorage.getItem('navbar');
      let storageLogo = sessionStorage.getItem('logo');
      let storageBgImg = sessionStorage.getItem('bgImg');
      if(storageNavbar && storageLogo && storageBgImg){
        try {
          this.navlist = JSON.parse(storageNavbar)
          this.logoSrc = storageLogo
          document.getElementsByTagName("body")[0].style.backgroundImage = storageBgImg
          if(!Object.keys(this.navlist).length) throw '导航为空'
          if(!storageLogo.length) throw 'logo为空'
          if(!storageBgImg.length) throw '背景图为空'
          return true;
        }catch (e) {
          console.error(e)
        }
      }
      let fields  = {
        rtime: apiSign.getTime()
      }
      this.axios
        .get(this.axios.defaults.baseURL + "/yiwei/app/init",
          {
            headers: {
              sign: apiSign.sign(fields)
            },
            params: fields
          }
        )
        .then(resp => {
          if(resp.data.code){
            this.$message({
              type: 'error',
              message: resp.data.msg
            });
          }else{
            if ('navbar' in resp.data.data && 'logo' in resp.data.data && 'background' in resp.data.data){
              let elementBody = document.getElementsByTagName("body")[0];
              let bg_img = 'url('+resp.data.data.background;+')';
              this.logoSrc = resp.data.data.logo;
              elementBody.style.backgroundImage = bg_img
              this.navlist = resp.data.data.navbar
              sessionStorage.setItem('navbar', JSON.stringify(this.navlist))
              sessionStorage.setItem('logo', this.logoSrc)
              sessionStorage.setItem('bgImg', bg_img)
            }else{
              this.$message({
                type: 'error',
                message: '初始化数据失败'
              });
            }
          }
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: err
          });
        });
    },
    childLink(data) {
      this.$store.state.membersYear = data;
      sessionStorage.setItem('membersName',data);
      sessionStorage.removeItem('yiweiId');
    },
    yiweiFn(){
      sessionStorage.removeItem('yiweiId');
    },
    searchFn(seachval){
      this.$store.state.searchVal =seachval;
    }
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped lang='less'>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
